module.exports = __webpack_public_path__ + "img/ug316.d0df58f1.png";